import { Component, OnDestroy } from '@angular/core';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { PusherService } from '@app/shared/services/pusher/pusher.service';
import { SettingsService } from '@app/shared/services/settings/settings.service';
import { Logger } from '@app/shared/utils';
import { Subscription, timer } from 'rxjs';
import { fadeInUpAnimation } from 'src/animations';

@Component({
  standalone: false,
  selector: 'sbnb-connect-airbnb-flow',
  templateUrl: './connect-airbnb-flow.component.html',
  styleUrls: ['./connect-airbnb-flow.component.scss'],
  animations: [fadeInUpAnimation],
})
export class ConnectAirbnbFlowComponent implements OnDestroy {
  currentStep: 'preconnect' | 'preconnect-limited' | 'connect-pending' = 'preconnect';

  connectUrls: { pms: string; legacy: string };

  connectPendingStage: 'newtab' | 'checking' | 'checking-with-redirect' | 'connected' | 'error' = 'newtab';
  pusherSub: Subscription;

  constructor(
    private settingsService: SettingsService,
    private deviceDetectionService: DeviceDetectionService,
    private pusherService: PusherService
  ) {
    this.getConnectionUrls();
  }

  ngOnDestroy(): void {
    if (this.pusherSub?.unsubscribe) {
      this.pusherSub.unsubscribe();
    }
  }

  getConnectionUrls() {
    this.settingsService.getAccounts().subscribe((res) => {
      this.connectUrls = {
        pms: res.meta.airbnb_pms_auth_url,
        legacy: res.meta.airbnb_auth_url,
      };
    });
  }

  connectToAirbnb(url: string) {
    // We cant open in a new tab on iOS right now
    if (this.deviceDetectionService.isIosApp()) {
      window.location.href = url;
      return;
    }

    // open in a new tab
    // we do this because Airbnb is terrible at handling redirects if the flow results in an error (e.g. already connected to another pms)
    // @TODO: We'll go further here and change the contents of this window too
    window.open(url, '_blank');
    this.currentStep = 'connect-pending';

    this.startConnectionPendingTimer();
  }

  private startConnectionPendingTimer() {
    const checkingTimer = timer(4000).subscribe(() => {
      this.connectPendingStage = 'checking';
    });

    const checkingWithRedirectTimer = timer(10000).subscribe(() => {
      this.connectPendingStage = 'checking-with-redirect';
    });

    this.pusherSub = this.pusherService.airbnbConnectionStatusUpdate$.subscribe((data) => {
      Logger.log(`Component: Airbnb connection status update event received. ${JSON.stringify(data)}`);

      if (data.connectionSuccess) {
        this.connectPendingStage = 'connected';
      } else {
        this.connectPendingStage = 'error';
      }

      if (this.pusherSub?.unsubscribe) {
        this.pusherSub.unsubscribe();
      }

      // cancel the timers
      if (checkingTimer?.unsubscribe) {
        checkingTimer.unsubscribe();
      }
      if (checkingWithRedirectTimer?.unsubscribe) {
        checkingWithRedirectTimer.unsubscribe();
      }
    });
  }
}
